import { Timestamp } from "firebase/firestore";
import { createPeriod } from "../services/firestore.service";
import { INewPeriod } from "../interfaces/new-period.interface";
import { useAppDispatch } from "../hooks";
import { dismiss } from "../slices/dialogsSlice";

interface AddPeriodDialogProps {
    projectId: string;
    categoryId: string;
    updatePeriods: () => void;
    dialogId: number;
}

export const AddPeriodDialog = ({
    projectId,
    categoryId,
    updatePeriods,
    dialogId,
}: AddPeriodDialogProps) => {
    const dispatch = useAppDispatch();

    const close = () => {
        dispatch(dismiss(dialogId));
    };

    const saveProject = (e) => {
        e.preventDefault();

        let data = new FormData(e.target);

        let date = data.get("date").toString();
        let startTime = data.get("start-time").toString();
        let endTime = data.get("end-time").toString();

        let startTimestamp = Date.parse(`${date}T${startTime}`);
        let endTimestamp = !!endTime ? Date.parse(`${date}T${endTime}`) : null;

        if (isNaN(startTimestamp)) {
            return;
        }

        let startDate = new Date(startTimestamp);
        let endDate = !endTimestamp || isNaN(endTimestamp) ? null : new Date(endTimestamp);

        let newPeriod: INewPeriod = {
            title: data.get("title").toString(),
            startDateTime: new Timestamp(startDate.getTime() / 1000, 0),
            endDateTime: !endDate ? null : new Timestamp(endDate.getTime() / 1000, 0),
            chargable: !!data.get("chargable"),
            assignedTo: data.get("assigned-to").toString(),
        };

        createPeriod(projectId, categoryId, newPeriod).then((r) => {
            updatePeriods();
            close();
        });
    };

    return (
        <>
            <form onSubmit={saveProject}>
                <h1>Add a new Period</h1>

                <input placeholder="Title" name="title" />
                <input placeholder="Date" name="date" type="date" />
                <input placeholder="Start" name="start-time" type="time" />
                <input placeholder="End" name="end-time" type="time" />

                <div className="checkbox-container">
                    <input id="chargable" name="chargable" type="checkbox" />
                    <label htmlFor="chargable">Chargable</label>
                </div>

                <select name="assigned-to">
                    <option value="" disabled>
                        Assigned To
                    </option>
                    <option value="Daryl">Daryl</option>
                    <option value="Josh">Josh</option>
                </select>

                <button type="submit">Save</button>
            </form>
            <button className="warn" onClick={close}>
                Cancel
            </button>
        </>
    );
};